export enum Hooks {
  MUCH_WORK = 'SINAN_MUCH_WORK',
  WAS_WORTH_IT = 'SINAN_WAS_WORTH_IT',
  DESIGN = 'SINAN_DESIGN',
  WHAT_DO_YOU_WANT_TO_KNOW = 'WHAT_DO_YOU_WANT_TO_KNOW',
  DETAILS = 'SINAN_DETAILS'
}
